import { z } from "zod";

export const DataFieldTypeSchema = z.enum([
  "text",
  "textarea",
  "number",
  "boolean",
  "select",
  "color",
  "asset",
]);
export type DataFieldType = z.infer<typeof DataFieldTypeSchema>;

export const BaseDataFieldSchema = z.object({
  type: DataFieldTypeSchema,
  label: z.string(),
  visibleAt: z.object({ start: z.number(), end: z.number() }).optional(),
});
export type BaseDataField = z.infer<typeof BaseDataFieldSchema>;

export const DataFieldText = BaseDataFieldSchema.extend({
  type: z.literal("text"),
  value: z.string(),
  maxLength: z.number().optional(),
  placeholder: z.string().optional(),
});
export type DataFieldText = z.infer<typeof DataFieldText>;

export const DataFieldTextArea = BaseDataFieldSchema.extend({
  type: z.literal("textarea"),
  value: z.string(),
  rows: z.number().optional(),
  placeholder: z.string().optional(),
});
export type DataFieldTextarea = z.infer<typeof DataFieldTextArea>;

export const DataFieldNumber = BaseDataFieldSchema.extend({
  type: z.literal("number"),
  value: z.number(),
  min: z.number().optional(),
  max: z.number().optional(),
  step: z.number().optional(),
});
export type DataFieldNumber = z.infer<typeof DataFieldNumber>;

export const DataFieldBoolean = BaseDataFieldSchema.extend({
  type: z.literal("boolean"),
  value: z.boolean(),
});
export type DataFieldBoolean = z.infer<typeof DataFieldBoolean>;

export const DataFieldSelect = BaseDataFieldSchema.extend({
  type: z.literal("select"),
  value: z.string(),
  options: z.array(z.string()),
});
export type DataFieldSelect = z.infer<typeof DataFieldSelect>;

export const DataFieldColor = BaseDataFieldSchema.extend({
  type: z.literal("color"),
  value: z.string().regex(/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/),
});
export type DataFieldColor = z.infer<typeof DataFieldColor>;

export const DataFieldAsset = BaseDataFieldSchema.extend({
  type: z.literal("asset"),
  value: z.string().nullable(),
  accept: z.array(z.string()).optional(),
});
export type DataFieldAsset = z.infer<typeof DataFieldAsset>;

export const DataFieldSchema = z.discriminatedUnion("type", [
  DataFieldText,
  DataFieldTextArea,
  DataFieldNumber,
  DataFieldBoolean,
  DataFieldSelect,
  DataFieldColor,
  DataFieldAsset,
]);
export type DataField = z.infer<typeof DataFieldSchema>;

export const DataSchema = z.record(DataFieldSchema);
export type Data = z.infer<typeof DataSchema>;
export type DataValues = { [key: string]: Data[keyof Data]["value"] };
